export default function SecurityShieldIcon({ className = "" }) {
    return (
        <svg
            viewBox="0 0 16 16"
            aria-hidden="true"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M8 2.2 12.8 4v4.1c0 2.9-2 4.7-4.8 5.7-2.8-1-4.8-2.8-4.8-5.7V4z" />
        </svg>
    );
}
